import React, { useEffect, useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import AddCategoryModal from '../../../Components/Modal/AddCategory.modal'
import { AdminService } from '../../../services/admin.service'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical, faPlus, faPenToSquare, faTrash, faListCheck } from '@fortawesome/free-solid-svg-icons'
import CustomToggle from '../../../Components/toggle'
import EditCategoryModal from '../../../Components/Modal/EditCategory.modal'
import toast from 'react-hot-toast'

export default function ExamCategory() {

    const [showCategoryModal, setShowCategoryModal] = useState<boolean>(false)
    const [showEditCategoryModal, setShowEditCategoryModal] = useState<number>(-1)
    const [categoriesData, setCategoriesData] = useState<any>();

    const getAllExamCategories = async () => {
        await AdminService.getAllExamCategories().then((res) => {
            if (res.status === 200) {
                setCategoriesData(res.data)
            }
        })
    }

    const handleDeleteExamCategory = async (id: any) => {
        await AdminService.deleteExamCategory(id).then((res) => {
            if (res.status === 200) {
                getAllExamCategories();
                toast.success("Delelted")
            }
        }).catch(err => {
            toast.error(err.response.data)
        })
    }

    useEffect(() => {
        getAllExamCategories()
    }, [])

    return (
        <>
            <div>
                <div className="ds-page-head">
                    <div className="d-flex align-items-center">
                        <h1 className="ds-page-title">Exam Category</h1>
                        <span className="ds-count-pill">
                            {categoriesData ? categoriesData.length : 0}
                        </span>
                    </div>
                    <button
                        className="ds-btn ds-btn-primary ds-btn-sm"
                        onClick={() => setShowCategoryModal(true)}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        Add Category
                    </button>
                </div>

                <div className="ds-cat-grid">
                    {categoriesData && categoriesData.length > 0 && categoriesData.map((data: any, index: number) => {
                        return (
                            <div className="ds-card ds-card-hover ds-cat-card" key={data._id || index}>
                                <div className="ds-cat-top">
                                    <span className="ds-kpi-icon">
                                        <FontAwesomeIcon icon={faListCheck} />
                                    </span>
                                    <Dropdown align="end">
                                        <Dropdown.Toggle
                                            as={CustomToggle}
                                            id="dropxdown-custom-components"
                                        >
                                            <span className="ds-icon-btn">
                                                <FontAwesomeIcon icon={faEllipsisVertical} />
                                            </span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => setShowEditCategoryModal(index)}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                className="ds-item-danger"
                                                onClick={() => handleDeleteExamCategory(data._id)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                                Delete
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <div className="ds-cat-name text-capitalize">{data.name}</div>
                                <div className="ds-cell-label">
                                    Created {moment(data.createdAt).format("DD MMM YYYY")}
                                </div>

                                <div className="ds-cat-foot">
                                    <span
                                        className={`ds-badge ${data.allowed ? "ds-badge--success" : "ds-badge--neutral"}`}
                                    >
                                        <span className="ds-dot" />
                                        {data.allowed ? "Allowed" : "Disabled"}
                                    </span>
                                    <Form.Switch checked={data.allowed} readOnly />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <AddCategoryModal
                show={showCategoryModal}
                handleClose={() => { setShowCategoryModal(false); getAllExamCategories() }}
            />

            <EditCategoryModal
                show={showEditCategoryModal >= 0 ? true : false}
                handleClose={() => { setShowEditCategoryModal(-1); getAllExamCategories() }}
                categoryData={categoriesData && categoriesData[showEditCategoryModal]}
            />
        </>
    )
}
